import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Button, Collapse, Grid, TextField } from "@mui/material";
import { useState } from "react";
import { updateContact, validEmail, validPhoneNumber } from "./client_halper";

function ContactEdit({ client, onChange }) {
    const [inputErrors, setInputErrors] = useState({});
    const [expanded, setExpanded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (isLoading) return;
        setIsLoading(true);
        const data = new FormData(event.currentTarget);
        const phone = data.get("phone").replace(/^(\+91|0)/, '').trim();
        const email = data.get("email");
        var flag = true;
        if (__error_handler(validPhoneNumber(phone), "phone", "You have not entered a valid phone number.")) {
            flag = false;
        }
        if (__error_handler(validEmail(email), "email", "Invalid email address.")) {
            flag = false;
        }
        if (flag) {
            const _json = {
                "phone": phone, "email": email, "client": client.client_id
            };
            updateContact(_json).then((_) => {
                delete _json["auth"];
                onChange({ status: "loaded", message: "change", change: _json });
                setIsLoading(false);
            }).catch((err) => {
                onChange({ status: "loaded", message: "failed", error: err.message });
                setIsLoading(false);
            });
        } else {
            onChange({ status: "loaded", message: "validation_error" });
            setIsLoading(false);
        }
    }

    const validateInputs = (event) => {
        onChange({ status: "loading" });
        return true;
    }

    return (
        <Box>
            <Button style={{ textTransform: "none" }} onClick={() => { setExpanded(!expanded); }}>
                {expanded ? <ExpandMore /> : <ExpandLess />} Contact Information
            </Button>
            <Collapse in={expanded} timeout="auto" unmountOnExit sx={{ mt: 1 }}>
                <Grid container spacing={2} component="form" onSubmit={handleSubmit} noValidate>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="phone" defaultValue={client.phone} fullWidth error={inputErrors.phone} type="text" helperText={inputErrors.phone} placeholder="Phone" label="Phone" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="email" fullWidth defaultValue={client.email} error={inputErrors.email} type="text" helperText={inputErrors.email} placeholder="Ex: mail@example.com" label="E Mail" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }} className="align_text">
                        <Button type="submit" variant="outlined" fullWidth onClick={validateInputs} color="secondary" sx={{ p: { xs: null, sm: 1.7 } }}>Save</Button>
                    </Grid>
                </Grid>
            </Collapse>
        </Box>
    );
}

export default ContactEdit;
